export default __webpack_public_path__ + "static/keyrus-intro-pt-6bbf4c48540a9544801b595c086c25a1.mp4";